import script from "./FormInput.vue?vue&type=script&setup=true&lang=js"
export * from "./FormInput.vue?vue&type=script&setup=true&lang=js"

import "./FormInput.vue?vue&type=style&index=0&id=07a58bf6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07a58bf6"]])

export default __exports__